<template>
  <div class="lotto-name-with-icon">
    <span
      v-if="countryCode"
      class="flag-icon flag-icon-rounded lotto-name-flag"
      :class="`flag-icon-${countryCode}`"
      aria-hidden="true"
    />
    <span class="lotto-name-text">{{ displayName }}</span>
  </div>
</template>

<script>
import { getCountryCode } from '@core/utils/countryFlag'

export default {
  name: 'LottoNameWithIcon',
  props: {
    lottoName: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayName() {
      return this.lottoName || '-'
    },
    countryCode() {
      return getCountryCode(this.lottoName)
    },
  },
}
</script>

<style scoped>
.lotto-name-with-icon {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 0.625rem;
  vertical-align: middle;
  white-space: nowrap;
}

.lotto-name-flag {
  width: 1.75rem !important;
  min-width: 1.75rem;
  max-width: 1.75rem;
  height: 1.75rem !important;
  min-height: 1.75rem;
  max-height: 1.75rem;
  flex: 0 0 1.75rem;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 50% !important;
  background-size: cover !important;
  box-shadow: 0 0 0 1px rgba(34, 41, 47, 0.12);
}

.lotto-name-text {
  font-weight: 600;
  line-height: 1.25;
}
</style>
